// import React from 'react';
import React from 'preact/compat';
// import ReactDOM from 'react-dom';
import { render } from 'preact';
import App from './App';
const sourceUrl = document.getElementById('source-url').value
const pageLink = document.getElementById('page-link').value

render(<App dataOrigin={sourceUrl} pageLink={pageLink} />, document.getElementById('tabela-teste'));